:root {
    --scrollbar-track-color: var(--color-bg-200);
    --scrollbar-thumb-color: var(--color-fg-600);
}

@layer base {
    :where(*:has(>.scrollbar.vertical)) {
        overflow-y: hidden;
    }

    :where(*:has(>.scrollbar.horizontal)) {
        overflow-x: hidden;
    }

    :where(*:has(>.scrollbar.both)) {
        overflow: hidden;
    }

    .scrollbar {
        min-width: 100%;
        position: relative;
        max-height: 100%;
    }
}

.scrollbar {
    /**
     * not compatible with scrollbar styles
     */
    resize: none;

    &.vertical {
        overflow: hidden scroll;
    }

    &.horizontal {
        overflow: scroll hidden;
    }

    &.both {
        overflow: scroll;
    }

    &::-webkit-scrollbar {
        height: 16px;
        width: 16px;
    }

    &::-webkit-scrollbar-track {
        background-color: var(--scrollbar-track-color);
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-thumb-color);
        min-height: 40px;
    }

    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
        background-clip: padding-box;
        border: 4px solid transparent;
        border-radius: 8px;
    }

    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }
}
